import React, { Component, ErrorInfo, ReactNode } from 'react';
import Erro from '../../pages/Erro';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.log('[ErrorBoundary]', error, info);
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      return <Erro error={this.state.error} onRetry={this.reset} />;
    }
    return this.props.children;
  }
}
